import '@/Fi16100/Sass/app.scss';
import React, {useContext, useEffect, useState} from 'react';
import {usePage} from '@inertiajs/react';
import Alert from 'react-bootstrap/Alert';
import Navigation from '@/Fi16100/Components/Navigation';
import Footer from '@/Fi16100/Components/Footer';
import SkipToMainLink from '@/Fi16100/Components/SkipToMainLink';
import {isMobile} from 'react-device-detect';
import PropTypes from 'prop-types';
import {I18nContext} from 'react-i18next';
import CookieConsent from '@/Fi16100/Components/CookieConsent/CookieConsent';

function Layout(props) {
	const t = useContext(I18nContext).i18n.t;
	const {error, success, info, cookieConsent} = usePage().props;
	const [showError, setShowError] = useState(!!error);
	const [showSuccess, setShowSuccess] = useState(!!success);
	const [showInfo, setShowInfo] = useState(!!info);
	const [showCookieConsent, setShowCookieConsent] = useState(cookieConsent === null);

	useEffect(() => {
		setShowError(!!error);
		setShowSuccess(!!success);
	}, [error, success]);

	useEffect(() => {
		if(typeof window.onPageView == 'function')
			window.onPageView(cookieConsent);
	}, [usePage().props]);

	const mainClassName = (props.mainClassName ?? '')
		+ ' position-relative flex-grow-1'
		+ (isMobile ? ' mobile' : '')

	return (
		<>
			<SkipToMainLink href="#main" className="top-0 start-0 m-3 btn btn-dark"/>

			<Navigation />

			<main id="main" className={mainClassName}>
				{showError &&
					<Alert variant="danger"
						   className="top-alert border-0 rounded-0 m-0 text-center"
						   dismissible
						   onClose={() => setShowError(false)}
						   closeLabel={t('app.close')}>
						<div className="d-flex justify-content-center align-items-center">
							<span className="px-3">{String(error)}</span>
						</div>
					</Alert>
				}

				{showInfo &&
					<Alert variant="info"
						   className="top-alert border-0 rounded-0 m-0 text-center"
						   dismissible
						   onClose={() => setShowInfo(false)}
						   closeLabel={t('app.close')}>
						<div className="d-flex justify-content-center align-items-center">
							<span className="px-3">{String(info)}</span>
						</div>
					</Alert>
				}

				{showSuccess &&
					<Alert variant="success"
						   className="top-alert border-0 rounded-0 m-0 text-center"
						   dismissible
						   onClose={() => setShowSuccess(false)}
						   closeLabel={t('app.close')}>
						<span className="px-3">{String(success)}</span>
					</Alert>
				}

				<div className="d-flex">
					{props.children}
				</div>
			</main>

			<Footer />

			<CookieConsent
				show={showCookieConsent}
				onHide={() => setShowCookieConsent(false)}
			/>
		</>
	);
}

Layout.propTypes = {
	className: PropTypes.string,
	mainClassName: PropTypes.string
}

export default Layout;
